import { render, staticRenderFns } from "./SurveyOnlineUser.vue?vue&type=template&id=22ba68e5&"
import script from "./SurveyOnlineUser.vue?vue&type=script&lang=js&"
export * from "./SurveyOnlineUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports